module.exports = __webpack_public_path__ + "img/SIMA_logo.e69b8c11.png";